const t = Object.keys;
function i(n) {
  return !!n;
}
function e(n) {
  return n != null;
}
function o(n) {
  return n !== void 0;
}
export {
  t as getKeys,
  o as isDefined,
  e as isNotNil,
  i as isTruthy
};
//# sourceMappingURL=types3.mjs.map
